import React from 'react';

import './docContainer.scss';

const DocContainer: React.FC = (props) => {
    return <div className="doc-container">
        {props.children}
    </div>;
}

export default DocContainer;